import { useEffect } from "react";
import Lenis from "lenis";

/**
 * Global smooth-scroll provider using Lenis.
 * Momentum scrolling with anchor-link support (#offerte etc.).
 */
export default function SmoothScroll() {
  useEffect(() => {
    // Respect reduced-motion preference
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
    });

    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    // Hijack in-page anchor clicks for smooth scroll via Lenis
    const onAnchorClick = (e) => {
      const link = e.target.closest('a[href^="#"], a[href*="/#"]');
      if (!link) return;
      const href = link.getAttribute("href");
      const idx = href.indexOf("#");
      if (idx === -1) return;
      const id = href.slice(idx + 1);
      if (!id) return;
      const el = document.getElementById(id);
      if (!el) return;
      // Only intercept if same route
      if (href.startsWith("#") || href.startsWith(window.location.pathname + "#")) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80, duration: 1.25 });
        // update url hash without jump
        history.replaceState(null, "", `#${id}`);
      }
    };
    document.addEventListener("click", onAnchorClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
    };
  }, []);

  return null;
}
